import request from '@/utils/request'

// 查询用户列表
export function listUser(para) {
    return request({
      url: '/system/user/pagelist',
      method: 'post',
      data: para
    })
}

// 查询用户详细
export function getUser(userId) {
    return request({
      url: '/system/user/detail/'+userId,
      method: 'get',
    })
}

// 新增用户
export function addUser(para) {
    return request({
      url: '/system/user/add',
      method: 'post',
      data: para
    })
}

// 修改用户信息
export function updateUser(para) {
    return request({
      url: '/system/user/edit',
      method: 'post',
      data: para
    })
}

// 删除用户（逻辑删除）
export function delUser(userId) {
    return request({
      url: '/system/user/remove',
      method: 'post',
      data: para
    })
}

/**
 * 修改密码
 * @param {*} para 
 */
export function resetUserPwd(para){
  return request({
    url: '/system/user/resetPwd',
    method: 'post',
    data: para
  })
}
/**
 * 修改状态
 */
export function changeUserStatus(para){
  return request({
    url: '/system/user/changeStatus',
    method: 'post',
    data: para
  })
}
/**
 * 部门列表
 * department list
 * @returns 
 */
export function deptTreeSelect(para) {
  return request({
    url: '/system/dept/list',
    method: 'post',
    data: para
  })
}

//查询用户id 下的授权角色
export function getAuthRole(userId){
  return request({
    url: '/system/user/authRole/' + userId,
    method: 'get'
  })
}

/**
 * 参数是用户id 和角色id数组
 */
export function updateAuthRole(para){
  return request({
    url: '/system/user/insertAuthRole',
    method: 'post',
    data: para
  })
}


// 查询用户个人信息
export function getUserProfile() {
  return request({
    url: '/system/profile/index',
    method: 'get'
  })
}

// 修改用户个人信息
export function updateUserProfile(params) {
  return request({
    url: '/system/profile/edit',
    method: 'post',
    data: params
  })
}

// 用户密码重置
export function updateUserPwd(params) {
 
  return request({
    url: '/system/profile/updatePwd',
    method: 'post',
    data: params
  })
}

// 用户头像上传
export function uploadAvatar(data) {
  return request({
    url: '/system/profile/avatar',
    method: 'post',
    data: data
  })
}
